import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, InputGroup, FormControl, Button, Pagination, Container, Row, Col, Dropdown } from 'react-bootstrap';
import Layout from "../../../layout/default";
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import Block from "../../../components/Block/Block";


const UserList = () => {
    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState('');
    // const [referNull, setReferNull] = useState('all'); // Default to 'all'
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [commissionData, setCommissionData] = useState([]);
    const authToken = localStorage.getItem('authToken');
    const [loading, setLoading] = useState(false); // State for loading

    // Fetch users from the API
    const fetchUsers = async (page = 1) => {
        setLoading(true); // Set loading to true when fetching
        Swal.fire({
            title: 'Loading...',
            text: 'Please wait while we fetch the data.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading(); // Show loading spinner
            },
        });
        
        try {
            let params = {
                search,
                page,
           
            };
            // Only add refernull if it's not 'all'
            
            const response = await axios.get(`${process.env.REACT_APP_HOST}api/get-users`, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
                params,
            });

            setUsers(response.data.data);
            setCurrentPage(response.data.current_page);
            setTotalPages(response.data.last_page);
        } catch (error) {
            console.error('Error fetching users:', error);
            Swal.fire('Error', 'Failed to load data. Please try again.', 'error');
        } finally {
            setLoading(false); // Set loading to false when fetching is done
            Swal.close(); // Close the loading alert
        }
    };

    // Fetch commission data from the API
    const fetchCommissionData = async () => {
        setLoading(true); // Set loading to true when fetching
        Swal.fire({
            title: 'Loading...',
            text: 'Please wait while we fetch the data.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading(); // Show loading spinner
            },
        });

        try {
            const response = await axios.get(`${process.env.REACT_APP_HOST}api/comissions`, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });
            setCommissionData(response.data); // Assuming response is an array of commission details
        } catch (error) {
            console.error('Error fetching commission data:', error);
            Swal.fire('Error', 'Failed to load commission data. Please try again.', 'error');
        } finally {
            setLoading(false); // Set loading to false when fetching is done
            Swal.close(); // Close the loading alert
        }
    };

    // Handle search input change
    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    // Handle search submission
    const handleSearchSubmit = (e) => {
        e.preventDefault();
        fetchUsers(1); // Fetch results from the first page
    };

    // Handle referNull filter change
    // const handleReferNullChange = (filter) => {
    //     setReferNull(filter);
    //     fetchUsers(1); // Fetch results from the first page
    // };

    // Handle page change
    const handlePageChange = (page) => {
        fetchUsers(page);
    };

    // Get the minimum order value for a given commission ID
    const getMinimumOrder = (comissionId) => {
        const commission = commissionData.find(item => item.id === comissionId);
        return commission ? commission.minimum_order : 'N/A'; // Return minimum order or 'N/A' if not found
    };

    useEffect(() => {
        fetchUsers();
        fetchCommissionData(); // Fetch commission data on component mount
    }, []);

    return (
        <Layout title="User List">
            <Block.HeadContent>
                <ul className="d-flex">
                    <li>
                        <Link
                            to="/shop/admin/admin-panel"
                            className="btn btn-primary btn-md d-md-none"
                        >
                            <span>Go To Panel</span>
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/shop/admin/admin-panel"
                            className="btn btn-primary d-none d-md-inline-flex"
                        >
                            <span>Go To Panel</span>
                        </Link>
                    </li>
                </ul>
            </Block.HeadContent>
            <Container className="mt-4">
                <Row className="mb-4">
                    <Col>
                        <h2>User List</h2>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col sm={8}>
                        <form onSubmit={handleSearchSubmit}>
                            <InputGroup>
                                <FormControl
                                    placeholder="Search by pincode or address"
                                    value={search}
                                    onChange={handleSearchChange}
                                />
                                <Button type="submit" variant="primary">
                                    Search
                                </Button>
                            </InputGroup>
                        </form>
                    </Col>
                    {/* <Col sm={4} className="d-flex justify-content-end">
                        <Dropdown>
                            <Dropdown.Toggle variant="secondary" id="referNullDropdown">
                                {referNull === 'all' ? 'Show All' : referNull === 'withReferral' ? 'With Referral' : 'Without Referral'}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => handleReferNullChange('all')}>Show All</Dropdown.Item>
                                <Dropdown.Item onClick={() => handleReferNullChange('withoutReferral')}>Without Referral</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col> */}
                </Row>
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>First Name</th>
                            <th>Middle Name</th>
                            <th>Last Name</th>
                            <th>Phone 1</th>
                            <th>Phone 2</th>
                            <th>Email</th>
                            <th>Pincode</th>
                            <th>user id</th>
                            <th>Referred By</th>
                            <th>Address</th>
                            <th>Comission ID</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.length > 0 ? (
                            users.map((user) => (
                                <tr key={user.id}>
                                    <td>{user.first_name}</td>
                                    <td>{user.middle_name || 'N/A'}</td>
                                    <td>{user.last_name}</td>
                                    <td>{user.phone_1}</td>
                                    <td>{user.phone_2 || 'N/A'}</td>
                                    <td>{user.email}</td>
                                    <td>{user.pincode}</td>
                                    <td>{user.user_id}</td>
                                    <td>{user.referred_by || 'N/A'}</td>
                                    <td>{user.user_address || 'N/A'}</td>
                                    <td>{getMinimumOrder(user.comission_id)}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="12" className="text-center">
                                    No users found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>

                {/* Pagination Section */}
                <Row className="justify-content-center">
                    <Col sm={12} className="d-flex justify-content-center">
                        <Pagination>
                            {[...Array(totalPages).keys()].map((page) => (
                                <Pagination.Item
                                    key={page + 1}
                                    active={page + 1 === currentPage}
                                    onClick={() => handlePageChange(page + 1)}
                                >
                                    {page + 1}
                                </Pagination.Item>
                            ))}
                        </Pagination>
                    </Col>
                </Row>
            </Container>
        </Layout>
    );
};

export default UserList;
